<div class="password-strength" *ngIf="password">
  <div class="password-strength__bar-track">
    <div class="password-strength__bar-fill" [style.width.%]="scorePercent"></div>
  </div>
  <p class="password-strength__label">{{ strengthLabel }}</p>
  <ul class="password-strength__requirements">
    <li *ngFor="let requirement of requirements" [class.met]="requirement.met">
      <i class="fa" [class.fa-check]="requirement.met" [class.fa-times]="!requirement.met"></i>
      {{ requirement.label }}
    </li>
  </ul>
</div>
